<template>
   <div>
    <el-dialog
        :title="tipData.tip_name"
        :visible.sync="dialogVisible"
        width="30%"
       >
        <div>
         <div class="center">
            <img src="../../assets/warn.png" alt="">
         </div>
         <div class="mb14 center" v-html="tipData.tip_description"></div>
         <span slot="footer" class="dialog-footer">
            <el-button plain @click="dialogVisible = false">关闭</el-button>
            <el-button type="primary" @click="goOrderAlter">确 定</el-button>
         </span>
        </div>
      </el-dialog>
   </div>
</template>

<script>
import { TipGroupPurchase,readTip } from "@/api/procure.js"
import { getCookie } from "@/utils/support";

// 本地company_id 对应 要传给接口的company_id
const companyfit = {
   '1': 2,
   '2': 5,
   '1,2':2,
}

 export default {
     data(){
        return{
          dialogVisible:false,
          timer: null,
          company_id: getCookie("company_id"),
          crmUser_id:getCookie('crmUser_id'),
          tipData:{}
        }
     },
     created() {

    },

    mounted() {
      this.getTip()
      // 页面加载完毕后启动定时器
      this.startRequest();
    },
   beforeDestroy() {
      // 清除定时器
      this.stopRequest();
   },
   watch:{
      dialogVisible(newVal, oldVal){
        if(newVal == true){
         //  打开弹窗的时候关闭定时器
         this.stopRequest()
        }else{
         //关闭弹窗的时候， 开启定时器
         this.startRequest()
        }
      }
   },
    methods: {
      startRequest() {
         this.timer = setInterval(() => {
         // 请求接口的操作
          this.getTip()
         }, 5000);
      },

      stopRequest() {
         clearInterval(this.timer);
         console.log('定时器已清除');
      },

      getTip(){
         var data = {
            user_id: this.crmUser_id,
            company_id: companyfit[this.company_id]
         }
         TipGroupPurchase(data).then(res=>{
            if(res.data.status == 200){
               // msg 不为空的时候显示
               if(res.data.msg !== null && res.data.msg != '' && res.data.msg.length > 0){
                   this.$message({
                     message: res.data.msg,
                     type: 'error',
                     duration: 2000,
                     offset:200
                  });
                  return
               }

               if(res.data.data){
                  this.dialogVisible = true
                  this.tipData = res.data.data
               }
            }else{
              console.log(res.data.msg);
            }
         })
      },

      //已读
      goOrderAlter(){
         var data = {
            user_id: this.crmUser_id,
            tip_id: this.tipData.tip_id
         }
         readTip(data).then(res=>{
            if(res.data.status == 200){
               this.dialogVisible = false
               window.open(this.tipData.link_address,'_self')
            }else{
               this.$message({
                  message: res.data.msg,
                  type: 'error',
                  duration: 2000,
                  offset:200
               });
            }
         })
      },

    }
 }
</script>

<style scoped lang="scss">
/* 弹窗头部 */
/deep/ .el-dialog__header {
  /* padding: 0; */
  padding: 16px 15px 16px 16px;
  border-bottom: 2px solid #eff0f3;
}

/deep/ .el-dialog__title{
   font-weight: 600;
}

/deep/ .el-dialog__body{
   padding: 26px 20px 40px 20px;
   color: #000000;
   font-size: 16px;
   font-weight: 600;
}
.center{
   text-align: center;
}

.mb14{
   margin-bottom: 14px;
}

/deep/.dialog-footer{
   float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/NeedImpart/index.vue